"use client";

type LogEntry = {
  timestamp: string;
  type: string;
  content: string;
};

const MAX_LOGS = 100;
let logs: LogEntry[] = [];
let isInitialized = false;

/**
 * 捕获控制台日志以便于随反馈上报
 */
export const consoleCapturer = {
  init() {
    if (isInitialized || typeof window === "undefined") return;

    const originalConsole = {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info,
    };

    const patch = (type: keyof typeof originalConsole) => {
      console[type] = (...args: unknown[]) => {
        // 调用原声方法
        originalConsole[type].apply(console, args);

        // 格式化参数并记录
        try {
          const content = args
            .map((arg) => {
              if (typeof arg === "object") {
                try {
                  return JSON.stringify(arg);
                } catch {
                  return String(arg);
                }
              }
              return String(arg);
            })
            .join(" ");

          logs.push({
            timestamp: new Date().toISOString(),
            type,
            content,
          });

          if (logs.length > MAX_LOGS) {
            logs.shift();
          }
        } catch {
          // ignore logging errors
        }
      };
    };

    patch("log");
    patch("warn");
    patch("error");
    patch("info");

    isInitialized = true;
    console.log("[ConsoleCapturer] Initialized");
  },

  getLogs() {
    return [...logs];
  },

  clear() {
    logs = [];
  },
};
